import { fetchCategories, filterOption } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { fetchTags } from "../../../../../tag/services/tag"
import { PostGridByCategoryProps, RenderGridTours } from "./RenderConfig"

const SelectCategory = ({ value, onChange }: any) => {
  const [optionCategories, setOptionCategories] = useState<{ value: string; label: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const fetchCategory = async () => {
    setLoading(true)

    try {
      const response = await fetchCategories()
      setOptionCategories(
        (response as { data: { id: string; attributes: { name: string } }[] }).data.map(
          (category: { id: string; attributes: { name: string } }) => ({
            value: category.id as string,
            label: category.attributes.name,
          }),
        ),
      )
    } catch (err) {
      message.error("Failed to fetch categories. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  return (
    <Select
      loading={loading}
      showSearch
      style={{ width: "100%" }}
      placeholder="Select Category"
      filterOption={filterOption}
      options={optionCategories}
      allowClear
      value={value}
      onChange={onChange}
    />
  )
}

const SelectTag = ({ value, onChange }: any) => {
  const [optionTags, setOptionTags] = useState<{ value: string; label: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const fetchTag = async () => {
    setLoading(true)

    try {
      const response = await fetchTags()
      setOptionTags(
        (response as { data: { id: string; attributes: { name: string; slug: string } }[] }).data.map(
          (tag: { id: string; attributes: { name: string; slug: string } }) => ({
            value: tag.attributes.slug as string,
            label: tag.attributes.name,
          }),
        ),
      )
    } catch (err) {
      message.error("Failed to fetch tags. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTag()
  }, [])

  return (
    <Select
      loading={loading}
      showSearch
      style={{ width: "100%" }}
      placeholder="Select Tag"
      filterOption={filterOption}
      options={optionTags}
      allowClear
      value={value}
      onChange={onChange}
    />
  )
}

const SelectItemsToRender = ({ value, onChange, totalItems }: any) => {
  const items = [3, 6, 9, "All"]
  return (
    <Select value={value} onChange={onChange} style={{ width: "100%" }} placeholder="Select number of items to display">
      {items.map(item => (
        <Select.Option key={item} value={item}>
          {item === "All" ? "All Items" : `${item} Items`}
        </Select.Option>
      ))}
    </Select>
  )
}

export const GridTours: ComponentConfig<PostGridByCategoryProps> = {
  label: "CaoCao | Grid Tours",

  fields: {
    categoryId: {
      type: "custom",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Select category to show tour</p>
          <SelectCategory {...props} />
        </div>
      ),
    },
    tag: {
      type: "custom",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Select tag to show tour</p>
          <SelectTag {...props} />
        </div>
      ),
    },
    colorPrimaryTag: {
      type: "text",
      label: "Color Primary Tag",
    },
    isAutoPlay: {
      type: "radio",
      label: "Auto Play",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    isLoopImage: {
      label: "Loop Image",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    showSearch: {
      label: "Show Search",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    showTitle: {
      label: "Show Title (Trips)",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    itemsToRender: {
      type: "custom",
      label: "Items to Render",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Choose number of items to display</p>
          <SelectItemsToRender {...props} />
        </div>
      ),
    },
  },
  defaultProps: {
    tag: undefined,
    categoryId: undefined,
    isAutoPlay: false,
    isLoopImage: false,
    showSearch: true,
    showTitle: true,
    itemsToRender: 3,
  },
  ...RenderGridTours,
}
